module.exports = __webpack_public_path__ + "static/media/Fazenda_story.f0ed9c10.jpg";